import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="564 819 580 832 689 811 711.72 832 856 803 856 777.78 864 776 891 791 1015 767 1015 738.59 1087 724 1117 737 1254 709 1254 695.89 1274 702 1327 692 1328 672 1425 654 1423 710 1244 745 1244 754 1013 804 1013 812 582 909 518 834 563 824 564 819"
      />

      <polygon
        data-floor="1"
        points="429 715 453 743 454 765 457 768 457 773.81 508 836 518 834 563 824 564 819 580 832 689 811 711.72 832 856 803 856 777.78 864 776 891 791 1015 767 1015 738.59 1087 724 1117 737 1254 709 1254 695.89 1274 702 1327 692 1328 672 1425 654 1428 604 1328 617 1328 633 1278 642 1257 638 1256 650 1119 673 1090 662 1015 674 1015 700 891 721 865 707 855 709 855 727 711 752 689 737 576 760 560 743 503 752 449 696 449 681 426 684 429 715"
      />

      <polygon
        data-floor="2"
        points="427 657 449 677 449 681 449 696 503 752 560 743 576 760 689 737 711 752 855 727 855 709 865 707 891 721 1015 700 1015 674 1090 662 1119 673 1256 650 1257 638 1278 642 1328 633 1328 617 1428 604 1430 550 1331 559 1331 573 1279 579 1260 575 1260 586 1119 606 1090 598 1017 605 1017 628 890 644 865 634 854 634 854 650 708 670 687 657 574 671 556 663 498 670 448 627 447 618 425 620 427 657"
      />

      <polygon
        data-floor="3"
        points="423 592 447 610 447 618 448 627 498 670 556 663 574 671 687 657 708 670 854 650 854 634 865 634 890 644 1017 628 1017 605 1090 598 1119 606 1260 586 1260 575 1279 579 1331 573 1331 559 1430 550 1433 494 1333 503 1333 511 1264 518 1143.39 533 1114 527 949 539 949 556 880 562 857 554 853 554 853 572 704 586 684 576 568 586 552 578 491 584 444 554 444 540 436 537 436 554 419 556 423 592"
      />

      <polygon
        data-floor="4"
        points="417 525 436 537 444 540 444 554 491 584 552 578 568 586 684 576 704 586 853 572 853 554 857 554 880 562 949 556 949 539 1114 527 1143.39 533 1333 511 1333 503 1433 494 1436 437 1336 443 1336 449 1145 467 1118 465 944 478 882 482 856 479 852 479 852 492 703 503 682 497 563 504 547 498 488 502 440 480 440 471 433 468 433 488 416 489 417 525"
      />

      <polygon
        data-floor="5"
        points="433 468 440 471 440 480 488 502 547 498 563 504 682 497 703 503 852 492 852 479 856 479 882 482 1118 465 1145 467 1336 449 1336 443 1436 437 1440 379 1338 382 1338 386 1268 387 1268 391 1147 396 1117 395 881 407 856 404 848 404 848 409 699 412 679 409 560 412 544 410 480 412 454 405 454 422 412 424 416 461.36 433 468"
      />

      <polygon
        data-floor="6"
        points="411 392 435 397 435 403.75 454 408.21 454 405 480 412 544 410 560 412 679 409 699 412 848 409 848 404 856 404 881 407 1117 395 1147 396 1268 391 1268 387 1338 386 1338 382 1440 379 1443 320 1332 322 1287 323 1258 323 1149 324 1000 326 871 327 727 328 544 330 447 326 449 354 407 355 408 385 411 385 411 392"
      />

      <polygon
        data-floor="7"
        points="395 323 447 326 544 330 720.49 328.07 931.94 326.53 1070.96 325.05 1189.04 323 1345.77 321.75 1443 320 1447 242 1303 239 1303 235 1234.36 235 1234 232 1199.87 232 1200 186 1164.69 186 1165 177 1160.83 177 1161 170 1133.37 170 1133 168 1087.07 168 1087 171 1047.81 168 1048 163 1016.04 163 1016 165 981 164 930 167 930 172 881 179 881 161 852.63 161 853 155 776 152 776 141 751 139 735 143 735 149 650 144 650 138 602 136 593 140 546.93 136 539 140 500 138 421 168 421 178 388 190 388 199.06 421 200 427 286 400 286 400 315 395 315 395 323"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
